// Copyright (c) Move Closer 2022.

import { Component, Vue } from 'vue-property-decorator'

import { IAuthMixin } from '../contracts'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
@Component
export class AuthMixin extends Vue implements IAuthMixin {
  public get isLoggedInUser (): boolean {
    return this.$store.getters['auth/isUserLoggedIn']
  }

  public get isUserB2B (): boolean {
    return this.$store.getters['auth/isUserB2B']
  }

  public get isUserPremium (): boolean {
    return this.$store.getters['auth/isUserPremium']
  }

  public get isWaitingForAuth (): boolean {
    return this.$store.getters['auth/isWaitingForAuth']
  }
}
